import React from 'react';
import formatTimestamp from 'utils/formatTimestamp';
import statusToColor from 'utils/statusToColor';

export default [
    {
        width: 60,
        flexGrow: 0.8,
        label: 'Name',
        dataKey: 'name'
    },
    {
        width: 60,
        flexGrow: 0.8,
        label: 'Organization',
        dataKey: 'organization_name',
        disableSort: true
    },
    {
        width: 60,
        flexGrow: 0.2,
        label: 'Status',
        dataKey: 'status',
        cellContentRenderer: status => <span style={{ color: statusToColor(status) }}>{status}</span>
    },
    {
        width: 150,
        flexGrow: 0.2,
        label: 'Last Status Change',
        dataKey: 'status_updated_at',
        cellContentRenderer: (timestamp, { timezone }) => formatTimestamp(timestamp, timezone),
        sortDirection: 'DESC'
    },
    {
        width: 140,
        flexGrow: 1.0,
        label: 'Devices',
        dataKey: 'devices',
        cellContentRenderer: devices => devices.map(device => `${device.name} (${device.status})`)
    }
];
